__turbopack_context__.v({
  "body": "dialog-module-scss-module__R6L0Ia__body",
  "footer": "dialog-module-scss-module__R6L0Ia__footer",
  "footerCenter": "dialog-module-scss-module__R6L0Ia__footerCenter",
  "footerEnd": "dialog-module-scss-module__R6L0Ia__footerEnd",
  "footerSpaceBetween": "dialog-module-scss-module__R6L0Ia__footerSpaceBetween",
  "footerStart": "dialog-module-scss-module__R6L0Ia__footerStart",
  "header": "dialog-module-scss-module__R6L0Ia__header",
});
